import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import Search from "../../components/inputs/Search";
import { BasicContext } from "../../App";
import LoadedRecords from "../../components/LoadedRecords";
import moment from "moment";
import Reservation from "../../components/Reservation";

const ReservationsList = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR, showView } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [originalList, setOriginalList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);

    const getReservationsList = async () => {
        const res = await postMethod(`${showView.params.moduleName === "ADMIN_APP" ? "/reservations-list" : "/reservations-list-view"}`, {
            moduleName: showView.params.moduleName,
        });
        if (checkServerData(res)) {
            setList(res.data.list);
            setOriginalList(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = originalList;
            filterThisList = filterThisList.filter(
                (el) =>
                    el.user_surname.toString().toLowerCase().includes(searchedPhrase) ||
                    el.user_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.instructor_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.instructor_surname.toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.class_start_time).format("DD.MM.YYYY HH:mm").toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.class_end_time).format("DD.MM.YYYY HH:mm").toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.ur_end_date).format("YYYY-MM-DD").toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(originalList);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getReservationsList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">{t("loadingData")}</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("reservations.reservationsList")}</h1>

                                <Button
                                    className="float-end d-inline-block me-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getReservationsList();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 my-3 px-lg-2 ">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table" size="sm">
                                            <tbody>
                                                {list
                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <Reservation
                                                                reserv={e}
                                                                reloadData={() => {
                                                                    setLoading(true);
                                                                    setTimeout(() => {
                                                                        getReservationsList();
                                                                    }, 200);
                                                                }}
                                                            />
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center my-3">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default ReservationsList;
